import React from "react"
import PropTypes from 'prop-types'
import {Provider} from "react-redux"
import {Route} from "react-router-dom"
import {ConnectedRouter} from "connected-react-router"
import App from './App'

const Root = ({store, history}) => (
	<Provider store={store}>
		<div>
			<ConnectedRouter history={history}>
				<Route path="/" component={App}/>
			</ConnectedRouter>
		</div>
	</Provider>
);

Root.propTypes = {
	store: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired
};
export default Root
